import React, { useEffect } from "react";
import { Link, Stack, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { buildTimelyPathUrl } from "./timelyClient";

/** Compatibility for saved booking URLs; scheduling runs in its own application. */
export default function ExternalTimelyRoute() {
  const location = useLocation();
  const url = buildTimelyPathUrl(location.pathname, location.search, location.hash);
  useEffect(() => { window.location.replace(url); }, [url]);
  return <Stack spacing={1} sx={{ p: 3 }}>
    <Typography>Opening Timely365…</Typography>
    <Link href={url}>Continue to Timely365</Link>
  </Stack>;
}
